import request from '@/utils/httpRequest'

export default {
    /**
     * 查询表单数据
     * @param {Object} id
     * @param {Object} url
     */
    queryById(id, url) {
        return request({
            url: url,
            method: 'get',
            params: {id: id}
        })
    },
    queryByParams(params, url) {
        return request({
            url: url,
            method: 'get',
            params
        })
    },
    queryByData(data, url) {
        return request({
            url: url,
            method: 'post',
            data
        })
    },
    queryByOtherId(idName, id, url) {
        return request({
            url: url,
            method: 'get',
            params: {[idName]: id}
        })
    },

    /**
     * 物料通用查询
     * @param {Object} id
     * @param {Object} url
     */
    queryByMater(id, url) {
        return request({
            url: url,
            method: 'post',
            params: {id: id},
            class: 'mater'
        })
    },
    /**
     * 启动流程
     * @param {Object} params
     * @param {Object} url
     */
    startFlow(params, url) {
        return request({
            url: url,
            method: 'post',
            data: params
        })
    },

    startFlow2(params, url) {
        return request({
            url: url,
            method: 'get',
            params: params
        })
    },

    getDataList(url, params) {
        return request({
            url: url,
            method: 'get',
            params: params
        })
    }
}
